import '../Cards.css';
import CardItem from '../CardItem';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function Freizeiten() {

  return (
    <div className="app-container">
      <div className="content">
        <h1 className="title">Ausflüge</h1>
        <p className="text">
          In der Vergangenheit haben wir viele spannende Ausflüge unternommen. Hier findest du eine Übersicht über unsere vergangenen Ausflüge.
        </p>

        <h2>Vergangene Ausflüge</h2>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ul className="cards__items">
            <CardItem
              src="images/pitztal_2026.png"
              text="Skifreizeit Februar 2026"
              alt="Skifreizeit Februar 2026"
              label="Vergangen"
              path="/freizeit/zukuenftig/skiausflug_2026"
            />
            <CardItem
              src="images/pitztal_2025.png"
              text="Skiausflug Januar 2025"
              alt="Skiausflug Januar 2025"
              label="Vergangen"
              path="/freizeit/vergangen/skiausflug_2025"
            />
          </ul>
        </div>

        <div className="download-section">
          <Link
            to="https://www.facebook.com/SkiClubBuch/?locale=de_DE"
            target="_blank"
            className="download"
            style={{ backgroundColor: "#3b5998" }}
          >
            <FaFacebook style={{ marginRight: "10px" }} />
            Facebook
          </Link>
          <Link
            to="https://www.instagram.com/schiclub_buch/"
            target="_blank"
            className="download"
            style={{ backgroundColor: "#E1306C" }}
          >
            <FaInstagram style={{ marginRight: "10px" }} />
            Instagram
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Freizeiten;
